import axios from 'axios';

export const getLogo = (grablogoparams) => {
    if(grablogoparams!=''){
        return axios.post('/content/get-client-addon-logo',{accountName:grablogoparams});
    }else{
        return axios.post('/content/get-client-addon-logo');
    }
};